export default function RightSidePanel() {
  return <div style={{ gridArea: "RightSidePanel" }}>RightSidePanel</div>;
}
